<template>
  <div class="container-fluid discounts-list mb-3">

    <div class="row d-none d-md-flex">

      <!-- Discount type list-->
      <div class="col-md-4 col-xl-3">
        <div class="panel p-0 position-relative">
          <div v-if="!discountTypeList" class="small-loader">
            <i class="mdi mdi-rotate-right mdi-spin"></i>
          </div>
          <discount-type-list-tree v-if="discountTypeList"
                                   :discount-type-list="discountTypeList"
                                   @onSelectDiscountTypes="selectDiscountTypes">
          </discount-type-list-tree>
        </div>
      </div>

      <!-- DiscountList-->
      <div v-if="discountLoader" class="col-md-8 col-xl-9 panel">
        <div class="small-loader">
          <i class="mdi mdi-rotate-right mdi-spin"></i>
        </div>
      </div>

      <div v-if="!discountLoader" class="col-md-8 col-xl-9 pl-0">

        <div class="panel">

          <div class="row mb-3">
            <div class="col-sm-12 text-right">
              <b-button variant="success"
                        type="button"
                        class="mx-1 text-nowrap"
                        @click="addNewDiscount()">
                <span class="mdi mdi-pencil"></span> {{ $t("#TR-add-new") }}
              </b-button>
            </div>
          </div>

          <table v-if="discountsList.length > 0"
                 class="table table-hover table-discounts">
            <thead>
              <tr class="font-weight-bold small">
                <th style="width: 40px;" class="text-center">{{ $t("#TR-code") }}</th>
                <th class="text-center">{{ $t("#TR-type") }}</th>
                <th>{{ $t("#TR-name") }}</th>
                <th>{{ $t("#TR-сlassification") }}</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(discount, idx) in discountsList"
                  :key="idx">
                <td>{{ discount['code'] }}</td>
                <td class="text-center icon">
                  <i v-if="discount['countType'] === 'Amount'"
                     class="mdi mdi-cash-multiple text-success"></i>
                  <i v-if="discount['countType'] === 'Percent'"
                     class="mdi mdi-ticket-percent text-primary"></i>
                </td>
                <td>{{ discount['name'] }}</td>
                <td>{{ discount['classification']
                  ? classificationsList.bySifr[discount['classification']].name
                  : '&mdash;' }}</td>
                <td class="receipt-btn preview"
                    :style="!discount['isEditable'] ? { opacity: 0.5, color: '#ccc' } : '' "
                    @click="discountView(discount)">
                  <span class="mdi mdi-eye-outline"></span>
                </td>
                <td class="receipt-btn edit"
                    :style="!discount['isEditable'] ? { opacity: 0.5, color: '#ccc' } : '' "
                    :class="{'disabled': !discount['isEditable']}"
                    @click="discountEdit(discount)">
                  <span class="mdi mdi-pencil"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="discountsList.length < 1" class="text-center text-muted my-5 font-weight-bold">
            <span v-if="!selectedDiscountType">{{ $t("#TR-select-discount-type") }}</span>
            <span v-if="selectedDiscountType">{{ $t("#TR-no-data") }}</span>
          </div>

        </div>
      </div>

    </div>

    <!-- Discount list small-->
    <div class="row d-flex d-md-none">
      <div class="col-12">

        <div class="panel py-2 px-1 mb-2">
          <div class="row">
            <div class="col-6">
              <b-button v-b-modal="'test-modal'" variant="secondary">
                <i class="mdi mdi-folder-multiple-outline m-0"></i>
              </b-button>
            </div>

            <div class="col-6 text-right">
              <b-button variant="success"
                        type="button"
                        class="mx-1 text-nowrap"
                        @click="addNewDiscount()">
                <span class="mdi mdi-pencil"></span> {{ $t("#TR-add-new") }}
              </b-button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 discount-list-small">
            <div v-for="(discount, idx) in discountsList"
                 :key="idx" class="discount-item shadow-sm">
              <div class="h">
                <div class="countType">
                  <i v-if="discount['countType'] === 'Amount'"
                     class="mdi mdi-cash-multiple text-success"></i>
                  <i v-if="discount['countType'] === 'Percent'"
                     class="mdi mdi-ticket-percent text-primary"></i>
                </div>
                <div class="code small text-success">
                  code: <span class="font-weight-bold">{{ discount['code'] }}</span>
                </div>
              </div>

              <div class="name text-secondary">{{ discount['name'] }}</div>

              <div class="classification">{{ discount['classification']
                ? classificationsList.bySifr[discount['classification']].name
                : '&mdash;' }}
              </div>

              <div class="discount-action">
                <div class="discount-action-item"
                     style="background: #5d4037;"
                     :style="!discount['isEditable'] ? { opacity: 0.5, background: '#ccc' } : '' "
                     @click="discountEdit(discount)">
                  <span class="mdi mdi-pencil"></span>
                </div>
                <div class="discount-action-item"
                     style="background: #00cf6e;"
                     :style="!discount['isEditable'] ? { opacity: 0.5, background: '#ccc' } : '' "
                     @click="discountView(discount)">
                  <span class="mdi mdi-eye-outline"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Discount type list Modal-->
    <b-modal id="test-modal"
             hide-footer
             scrollable
             size="lg"
             title="Discounts type">
      <div>
        <div v-if="!discountTypeList" class="small-loader">
          <i class="mdi mdi-circle-off-outline mdi-spin"></i>
        </div>
        <discount-type-list-tree
          v-if="discountTypeList"
          :discount-type-list="discountTypeList"
          @onSelectDiscountTypes="selectDiscountTypes">
        </discount-type-list-tree>
      </div>
    </b-modal>

    <discount-edit v-if="showEditDiscount"
                   ref="editDiscount"
                   :editable-discount="editableDiscount"
                   :classifications-list="classificationsList"
                   :discount-type-list="discountTypeList"
                   :selected-discount-type="selectedDiscountType"
                   @discountSaved="discountSaved"
                   @cancelViewEdit="cancelViewEdit">
    </discount-edit>

    <discount-view v-if="showViewDiscount"
                   ref="viewDiscount"
                   :viewed-discount="viewedDiscount"
                   :classifications-list="classificationsList"
                   @onEdit="discountEdit"
                   @cancelViewEdit="cancelViewEdit">
    </discount-view>

  </div>
</template>

<script>
  import { ApiEditor, ApiRefEditor } from '@/services/api';
  import DiscountView from '@/views/WebEditor/Discounts/Discounts-View';
  import DiscountEdit from '@/views/WebEditor/Discounts/Discounts-Edit';
  // import { Tree } from 'vue-draggable-nested-tree';
  import DiscountTypeListTree from '@/views/WebEditor/Discounts/DiscountTypeListTree';


  export default {
    name: 'Discounts',
    components: {
      DiscountView,
      DiscountEdit,
      DiscountTypeListTree
      // Tree
    },

    data() {
      return {
        discountsList: [],
        discountTypeList: null,
        classificationsList: {},
        selectedDiscountType: null,

        showViewDiscount: false,
        showEditDiscount: false,
        editableDiscount: null,
        viewedDiscount: null,
        discountLoader: false
      };
    },

    async created() {
      this.$store.commit('setPageTitle', '#TR-discounts');
      await this.getClassifications();
      await this.getDiscountTypes();
      // await this.getDiscountList();
    },

    methods: {

      async getClassifications() {
        const result = await ApiRefEditor.get('Classifications');

        this.classificationsList.bySifr = [];
        if (!result.error) {
          this.classificationsList.byIndex = result.data;
          this.classificationsList.byIndex.forEach(c => {
            this.classificationsList.bySifr[c.sifr] = c;
          });
        }
      },

      async getDiscountTypes() {
        const result = await ApiRefEditor.get('DiscountTypes');
        if (!result.error) {
          this.discountTypeList = this.buildTree(result.data, 0);
        } else {
          this.discountTypeList = [];
        }
      },

      buildTree(discountTypeList, pId) {
        return discountTypeList.reduce((r, e) => {
          e = Object.assign({}, e);
          e.open = false;
          e.active = false;
          if (e.parent === pId) {
            const children = this.buildTree(discountTypeList, e.sifr);
            if (children.length) e.children = children;
            r.push(e);
          }

          return r;
        }, []);
      },

      selectDiscountTypes(discountType) {
        this.selectedDiscountType = discountType;
        this.getDiscountList(discountType.sifr);
        this.$bvModal.hide('test-modal');
      },

      classificationsName(discounts) {

        discounts.forEach(d => {
          if (d.classification) {

            if (!this.classificationsList.bySifr[d.classification]) {
              this.classificationsList.bySifr[d.classification] = {
                guid: null,
                sifr: d.classification,
                name: '—',
                bad: true
              };
            }
          }
        });
      },

      async getDiscountList(sifr) {
        sifr = sifr || this.discountTypeList[0].sifr;
        this.discountLoader = true;
        const result = await ApiEditor.getDiscountList(sifr);

        if (!result.error) {
          this.discountsList = result.data;
          this.classificationsName(this.discountsList);

        } else {
          this.discountsList = [];
        }
        this.discountLoader = false;
      },

      addNewDiscount() {
        this.showViewDiscount = false;
        this.viewedDiscount = null;
        this.showEditDiscount = true;
        this.editableDiscount = {};
        this.$nextTick(() => {
          this.$refs.editDiscount.openDiscountEdit();
        });
      },

      discountEdit(discount) {
        if (!discount.isEditable) {
          return;
        }
        this.showViewDiscount = false;
        this.viewedDiscount = null;
        this.showEditDiscount = true;
        this.editableDiscount = discount;
        this.$nextTick(() => {
          this.$refs.editDiscount.openDiscountEdit();
        });
      },

      discountView(discount) {
        if (!discount.isEditable) {
          return;
        }
        this.showEditDiscount = false;
        this.editableDiscount = null;
        this.showViewDiscount = true;
        this.viewedDiscount = discount;
        this.$nextTick(() => {
          this.$refs.viewDiscount.openDiscountView();
        });
      },

      discountSaved() {
        this.selectDiscountTypes(this.selectedDiscountType);
        this.cancelViewEdit();
      },

      cancelViewEdit() {
        this.showViewDiscount = false;
        this.showEditDiscount = false;
        this.editableDiscount = null;
        this.viewedDiscount = null;
      }


    }
  };
</script>

<style lang="stylus">

.table-discounts {
    td {
        font-size: 14px
    }
    td.icon {
        font-size: 20px
        line-height: 24px
        color: c-accent
    }
}

    .discount-list-small {
        .discount-item {
            background: #fff
            border: 1px solid #efefef
            margin-bottom: 10px
            position: relative
            padding: 0 10px 10px 10px

            .h {
                display: flex

                .countType {
                    width: 40px
                    font-size: 24px
                }
                .code {
                    flex: auto
                    padding-top: 10px;
                }
            }

            .name {
                font-weight: 600
                font-size: 14px
            }

            .classification {
                font-size: 14px
            }

            .discount-action {
                position: absolute;
                top: 4px;
                right: 4px;
                height: 32px;

                .discount-action-item {
                    float: right
                    width: 32px
                    font-size: 18px
                    line-height: 30px
                    text-align: center
                    background: #bbc2c3
                    color: #fff
                    border-radius: 5px
                    margin-left: 5px
                    cursor pointer

                    &.delete {
                        background: #dc3545
                    }

                    &:hover {
                        background: c-accent
                    }

                    &.delete:hover {
                        background: #f00
                    }
                }
            }
        }
    }

      .darkmode {
        .discount-list-small {
          .discount-item {
            background: c-dark-bg
            border: 1px solid c-dark-bg-light
          }
        }

      }



</style>
